import { ref, onMounted, onUnmounted } from 'vue'

/** 与 mobile.scss 断点保持一致 */
export const KB_MOBILE_MAX_WIDTH = 767

export function useBreakpoint() {
  const isMobile = ref(false)

  let mql = null

  function update() {
    isMobile.value = window.matchMedia(
      `(max-width: ${KB_MOBILE_MAX_WIDTH}px)`
    ).matches
    document.documentElement.classList.toggle('kb-mobile', isMobile.value)
    if (!isMobile.value) {
      document.documentElement.classList.remove('kb-sider-open')
    }
  }

  onMounted(() => {
    mql = window.matchMedia(`(max-width: ${KB_MOBILE_MAX_WIDTH}px)`)
    update()
    mql.addEventListener('change', update)
  })

  onUnmounted(() => {
    mql?.removeEventListener('change', update)
    document.documentElement.classList.remove('kb-mobile', 'kb-sider-open')
  })

  return { isMobile }
}
